const topics = [
  { label: '#绝世神医更新', heat: '热门' },
  { label: '#重生之都市修仙', heat: '爆火' },
  { label: '#总裁替身前妻结局', heat: '热议' },
  { label: '#暗影刺客第二季', heat: '期待' },
  { label: '#异世界开局满级', heat: '新番' },
  { label: '#九尾狐恋爱法则', heat: '甜宠' },
  { label: '#韩国漫画必看', heat: '推荐' },
  { label: '#高分韩国漫画', heat: '精选' },
  { label: '#免费韩国漫画', heat: '福利' },
  { label: '#韩国漫画排行榜', heat: '榜单' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">热门话题</h2>
          <p className="mt-3 text-sm text-foreground-600">韩国漫画社区热议标签 · 大家都在讨论什么</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 max-w-2xl mx-auto">
          {topics.map((t) => (
            <a
              key={t.label}
              href="#hero"
              onClick={(e) => { e.preventDefault(); document.querySelector('#hero')?.scrollIntoView({ behavior: 'smooth' }); }}
              className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-100 text-sm text-foreground-700 cursor-pointer hover:bg-primary-50 hover:text-primary-600 transition-colors whitespace-nowrap"
            >
              <span>{t.label}</span>
              <span className="text-xs px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 whitespace-nowrap">{t.heat}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}